<template>
	<v-dialog
			:value="isDialog"
			content-class="dialogWrapper"
			width="740"
			@input="onDialogInput"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>{{ title }}</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="text">{{ text }}</div>
				<div class="mapWrapper">
					<map-component v-if="isMap" ref="mapComponent" :lon="lon" :lat="lat"></map-component>
				</div>
				<div class="coordinatesTitle">
					🛰️ Coordinates:
				</div>
				<div class="coordinatesRow">
					<div class="item">
						<div class="text">lat: </div>
						<div class="value"><b>{{ lat }}</b></div>
					</div>
					<div class="item">
						<div class="text">lon: </div>
						<div class="value"><b>{{ lon }}</b></div>
					</div>
				</div>
			</div>
			<div class="dialogFooter">
				<div class="buttonGroups">
					<custom-btn
							margin="0"
							text="Close"
							custom-class="cancel"
							@updateEvent="onClose"
					></custom-btn>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import MapComponent from "@/shared/MapComponent.vue";

export default {
	name: "DialogMap",
	components: { MapComponent },
	props: {
		isDialog: Boolean,
		title: String,
		text: String,
		lat: String,
		lon: String,
	},
	data: () => ({
		isMap: false,
	}),
	methods: {
		onClose() {
			this.$emit("updateCloseMap");
		},
		onDialogInput(val) {
			if (!val) {
				this.onClose(); // Закрываем диалог
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.isMap = true;
			// Получаем экземпляр карты через цепочку $refs
			const mapComponent = this.$refs.mapComponent;
			if (
				mapComponent &&
					mapComponent.$refs.mapRef &&
					mapComponent.$refs.mapRef.mapObject
			) {
				mapComponent.$refs.mapRef.mapObject.invalidateSize();
			}
		});
	}
};
</script>

<style scoped lang="scss">
@import "../../components/Dispatch/Trips/DialogTrip/dialog";
.dialogMain {
	.text {
		font-size: 14px;
	}
	.mapWrapper {
		margin: 10px 0;
	}
	.coordinatesTitle {
		font-size: 14px;
	}
	.coordinatesRow {
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		.item {
			gap: 4px;
			display: flex;
			align-items: center;
		}
	}
}
</style>
